import { useApolloClient } from '@apollo/client';
import { isNil, omit } from 'lodash';
import { useCallback } from 'react';
import { Mutations } from '@shared/api';
import { toComponentOneOf } from '@shared/util/workflow';
import { refetchAndInvalidateQueriesAfterMutatingViewTemplates } from '../utils';

export function useUpdateViewTemplate(workflowTemplateId?: string | null) {
  const apollo = useApolloClient();

  return useCallback(
    (viewTemplate: Partial<MBAPI.ViewTemplate> & { id: string }) => {
      const mutationPreparedViewTemplate = omit(
        viewTemplate,
        'cardUITemplate',
        'createdAt',
        'updatedAt',
      ) as MBAPI.ViewTemplate;

      return apollo.mutate<
        MBAPI.UpdateViewTemplateMutation,
        MBAPI.UpdateViewTemplateMutationVariables
      >({
        mutation: Mutations.viewTemplate.updateViewTemplate,
        variables: {
          input: {
            ...mutationPreparedViewTemplate,
            defaultReadonlyComponents:
              mutationPreparedViewTemplate.type === 'COLLECTION' ? true : false,
            componentsViewOptions: viewTemplate.componentsViewOptions?.map(viewOption => {
              return {
                componentId: viewOption.componentId,
                isHidden: viewOption.isHidden,
                overrides: !isNil(viewOption.overrides)
                  ? toComponentOneOf(viewOption.overrides)
                  : null,
              };
            }),
            workflowTemplateId: workflowTemplateId ?? '',
          },
        },
        ...refetchAndInvalidateQueriesAfterMutatingViewTemplates(workflowTemplateId ?? null),
      });
    },
    [apollo, workflowTemplateId],
  );
}
